module.exports = __webpack_public_path__ + "img/Frühling.97f391ab.jpg";